// Live catalog provider — products are served by the backend from the
// merchant's Ecwid store (GET /api/catalog). The local PRODUCTS list in
// products.js is kept only as an offline fallback so the site never
// renders empty if Ecwid is unreachable.
import { createContext, useContext, useEffect, useState } from "react";
import { PRODUCTS as FALLBACK_PRODUCTS } from "@/data/products";

const CatalogContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export const CatalogProvider = ({ children }) => {
  const [products, setProducts] = useState(FALLBACK_PRODUCTS);
  const [loading, setLoading] = useState(true);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/api/catalog`)
      .then((r) => {
        if (!r.ok) throw new Error("catalog fetch failed");
        return r.json();
      })
      .then((d) => {
        if (!cancelled && Array.isArray(d.products) && d.products.length > 0) {
          setProducts(d.products);
          setLive(true);
        }
      })
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const value = {
    products,
    loading,
    live,
    getProduct: (id) => products.find((p) => p.id === id),
    newArrivals: products.filter((p) => p.tag === "new"),
    bestSellers: products.filter((p) => p.tag === "best"),
  };
  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
};

export const useCatalog = () => useContext(CatalogContext);
